<template>
  <header class="bg-white shadow-md sticky top-0 z-50 h-16">
    <nav class="container mx-auto px-4 h-full">
      <div class="flex justify-between items-center h-full">
        <!-- Logo -->
        <router-link to="/" class="flex items-center">
          <img src="@/assets/logo.png" alt="TechsPartner Logo" class="w-40 h-40 object-contain">
        </router-link>

        <!-- Mobile menu button -->
        <button @click="toggleMenu" class="md:hidden p-2 rounded-lg hover:bg-gray-100">
          <Menu v-if="!isOpen" class="w-6 h-6" :stroke="'#fff'" />
          <X v-else class="w-6 h-6" :stroke="'#fff'" />
        </button>

        <!-- Desktop Navigation -->
        <div class="hidden md:flex space-x-8">
          <router-link to="/" class="text-gray-700 hover:text-bleumarine font-medium transition" :class="{ 'text-bleumarine': $route.path === '/' }">Accueil</router-link>
          <router-link to="/services" class="text-gray-700 hover:text-turquoise font-medium transition" :class="{ 'text-turquoise': $route.path === '/services' }">Services</router-link>
          <router-link to="/about" class="text-gray-700 hover:text-violet font-medium transition" :class="{ 'text-violet': $route.path === '/about' }">À propos</router-link>
          <router-link to="/blog" class="text-gray-700 hover:text-gray-500 font-medium transition" :class="{ 'text-gray-500': $route.path.startsWith('/blog') }">Blog</router-link>
          <router-link to="/contact" class="text-gray-700 hover:text-bleumarine font-medium transition" :class="{ 'text-bleumarine': $route.path === '/contact' }">Contact</router-link>
        </div>
      </div>

      <!-- Mobile Navigation -->
      <div v-if="isOpen" class="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t">
        <div class="flex flex-col items-center space-y-4 py-6">
          <router-link @click="toggleMenu" to="/" class="text-gray-700 hover:text-bleumarine font-medium py-2" :class="{ 'text-bleumarine': $route.path === '/' }">Accueil</router-link>
          <router-link @click="toggleMenu" to="/services" class="text-gray-700 hover:text-turquoise font-medium py-2" :class="{ 'text-turquoise': $route.path === '/services' }">Services</router-link>
          <router-link @click="toggleMenu" to="/about" class="text-gray-700 hover:text-violet font-medium py-2" :class="{ 'text-violet': $route.path === '/about' }">À propos</router-link>
          <router-link @click="toggleMenu" to="/blog" class="text-gray-700 hover:text-gray-500 font-medium py-2" :class="{ 'text-gray-500': $route.path.startsWith('/blog') }">Blog</router-link>
          <router-link @click="toggleMenu" to="/contact" class="text-gray-700 hover:text-bleumarine font-medium py-2" :class="{ 'text-bleumarine': $route.path === '/contact' }">Contact</router-link>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { ref } from 'vue'
import { Menu, X } from 'lucide-vue-next'

const isOpen = ref(false)

const toggleMenu = () => {
  isOpen.value = !isOpen.value
}
</script>
